export const Colors = {
    main : "#50489C" , 
    main2 : "#736dae" , 
    main3 : "#50489cab" , 
    main4 : "#5654D4" , 
    main5 : "#122E74" ,
    main6 : "#50489C" ,
    yellow : "#FFFF00" ,
    orange : "#FFA500" ,  
    light : "#dad8e9" , 
    lightMain : "#3734CA1A" , 
    hoverMain: "#453c9c" , 
    second :"#455A64" , 
    input : "#C8C8C8" , 
    gray :"#8E8E93" , 
    gray2 :"#9291A5" , 
    gray_l : "#A5A5A5" ,
    gray_input : "#DBDBDB" , 
    body :"#F3F5F8" ,  
    olive : "#0E4F68" , 
    lightRed : "#FA433D66" , 
    grayDC : "#DCDCDC" , 
    bgBL: "#F5F7FB" , 
    red : "#C32B43" , 
    hoverRed : "#bb001e" , 
    green : "#27AE60" , 
    hoverGreen : "#00953f" , 
    bg: "#F7F7F7" , 
    hoverGray : "#cdcbcb" , 
    Black60:"#45464E" , 
    Gray1 :"#333333" , 
    Black3: "#8B8D97" , 
    input_fill : "#F5F5F5" , 
    gold : "#F3B51A" , 
    gold2 : "#F3B51A" , 
    hoverGold : "#f1ac00" ,
    lightGray : "#F7F7F9" , 
    danger : "#C32B43" , 
    success : "#12AB6C" , 
    lightSuccess : "#27AE601A" ,
    failed : "#B42318" ,
    lightFailed : "#C32B431A" ,
    black2 : "#1E1B39" ,
    black3 : "#040404" ,
    black4 : "#0A0B37" ,
    black5 : "#120101" ,
    black6 : "#080808" ,
    gray3 : "#F5F5F8" ,
    gray4 : "#5E5E6F" ,
    gray5 : "#EBEBEB" ,
    gray6 : "#7E8280" ,
    gray7 : "#E5E5EF" ,
    gray8 : "#615E83" ,
}
export const Dimensions = {
    sidebarWidth : "257px" ,
    navbarHeight : "73px" , 
}
